module.exports = __webpack_public_path__ + "img/US.c987f1d5.svg";